const fmt = (n) => String(Math.round(Number(n) * 100) / 100);

// Describe los cambios frente a la receta: "Sin cebolla", "+1 queso", "−1 tomate".
// items: [{ name, quantity, recipeQuantity }]
export function describePortionChanges(items) {
  const changes = [];
  for (const p of items || []) {
    const qty = Number(p.quantity) || 0;
    const recipe = Number(p.recipeQuantity) || 0;
    if (qty === recipe) continue;
    if (qty === 0) changes.push({ type: 'removed', text: `Sin ${p.name}` });
    else if (qty > recipe) changes.push({ type: 'extra', text: `+${fmt(qty - recipe)} ${p.name}` });
    else changes.push({ type: 'less', text: `−${fmt(recipe - qty)} ${p.name}` });
  }
  return changes;
}

// Clave para agrupar líneas del carrito con la misma personalización
export function portionsKey(portions) {
  if (!portions) return '';
  return portions
    .map(p => `${p.portionId}:${p.quantity}`)
    .sort()
    .join('|');
}
